
import {
  Vue, Component, PropSync,
} from 'vue-property-decorator';

@Component
export default class InputTimePicker extends Vue {
  @PropSync('timeValue', { required: true }) syncedTimeValue!: string;

  private showMenu = false;
}
